<script setup lang="ts">
import MenuItem from '@/components/FloatMenu/FloatMenuOption/indev.vue'

const { elementalId } = defineProps<{
  elementalId: string | number
}>()

const { copied, copy } = useClipboard()

const copyId = () => {
  copy(elementalId.toString())
}

defineOptions({
  name: 'CopyIdOption',
})
</script>

<template>
  <MenuItem no-close-after-select @select="copyId">
    <template #icon>
      <div v-if="copied" i-mdi:check w-3 h-3 />
      <IconElementalId v-else w-3 h-3 />
    </template>
    {{ elementalId.toString().slice(0, 18) }}
  </MenuItem>
</template>
